<app-common-report-form
  [formTitle]="'Kátyú bejelentő űrlap'"
  [formCategory]="'POTHOLE_REPORT'"
></app-common-report-form>
